import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  toastList: [],
};

const uiContextSlice = createSlice({
  name: 'uiContext',
  initialState,
  reducers: {
    showToast: (state, action) => {
      state.toastList = [...state.toastList, action.payload];
    },
    deleteToast: (state, action) => {
      const newList = state.toastList.filter(
        (toast) => toast.id !== action.payload
      );
      state.toastList = newList;
    },
  },
});

export const { showToast, deleteToast } = uiContextSlice.actions;

export default uiContextSlice.reducer;
